module.exports = __webpack_public_path__ + "static/media/falco.bf8f4083.png";